/**
 * Tiện ích hiển thị và thao tác thông báo dùng chung cho trang Thông báo và chuông
 * đầu trang (tách riêng để khung trang không phải nạp cả màn hình Thông báo).
 */
import { viThongBao } from '../ngon-ngu/vi-thong-bao';
import type { DongThongBao } from '../api/thong-bao-api';
import { napLaiSoChuaDoc } from '../trang-thai/thong-bao-chua-doc';

const DINH_DANG_GIO_VN = new Intl.DateTimeFormat('vi-VN', {
  timeZone: 'Asia/Ho_Chi_Minh',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
});

/** Thời điểm theo giờ Việt Nam, dạng `dd/mm/yyyy hh:mm`. */
export function thoiDiemThongBao(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  const p: Record<string, string> = {};
  for (const x of DINH_DANG_GIO_VN.formatToParts(d)) p[x.type] = x.value;
  return `${p.day}/${p.month}/${p.year} ${p.hour}:${p.minute}`;
}

export function nhanLoaiThongBao(loai: string): string {
  return viThongBao.loai[loai] ?? loai;
}

/**
 * Bấm một thông báo (trang danh sách hoặc chuông): đánh dấu đã đọc nếu chưa đọc,
 * rồi điều hướng tới `duongDan`. Lỗi đánh dấu không chặn điều hướng.
 */
export async function moThongBao(
  d: Pick<DongThongBao, 'id' | 'daDoc' | 'duongDan'>,
  danhDau: (id: string) => Promise<unknown>,
  dieuHuong: (duong: string) => void,
): Promise<void> {
  if (!d.daDoc) {
    try {
      await danhDau(d.id);
    } catch {
      /* điều hướng vẫn tiếp tục; lần sau người dùng đánh dấu lại được */
    }
    void napLaiSoChuaDoc();
  }
  if (d.duongDan) dieuHuong(d.duongDan);
}
